const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 50,
    style: {
      fill: "#21759B"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.5,64c0,10.9,6.3,20.3,15.5,24.7L38.9,52.8C37.4,56.2,36.5,60,36.5,64z M82.5,62.6   c0-3.4-1.2-5.7-2.3-7.6c-1.4-2.3-2.7-4.2-2.7-6.4c0-2.5,1.9-4.9,4.6-4.9c0.1,0,0.2,0,0.4,0c-4.9-4.5-11.4-7.2-18.5-7.2   c-9.6,0-18,4.9-22.9,12.4c0.6,0,1.3,0,1.8,0c2.9,0,7.3-0.4,7.3-0.4c1.5-0.1,1.7,2.1,0.2,2.3c0,0-1.5,0.2-3.1,0.3l10,29.7l6-18   L59,51.1c-1.6-0.1-3-0.2-3-0.2c-1.5-0.1-1.3-2.4,0.2-2.3c0,0,4.5,0.4,7.2,0.4c2.9,0,7.3-0.4,7.3-0.4c1.5-0.1,1.7,2.1,0.2,2.3   c0,0-1.5,0.2-3.1,0.3l9.9,29.5l2.7-9.1C81.8,67.9,82.5,65,82.5,62.6z M64.5,66.4l-8.2,23.9c2.5,0.7,5.1,1.1,7.8,1.1   c3.2,0,6.3-0.6,9.1-1.6c-0.1-0.1-0.1-0.2-0.2-0.4L64.5,66.4z M88.1,50.8c0.1,0.9,0.2,1.8,0.2,2.8c0,2.8-0.5,5.9-2.1,9.8l-8.4,24.2   C86,83,91.5,74.1,91.5,64C91.5,59.2,90.2,54.7,88.1,50.8z M32,64c0,17.6,14.4,32,32,32s32-14.4,32-32S81.6,32,64,32S32,46.4,32,64z    M33.5,64c0-16.8,13.7-30.5,30.5-30.5S94.5,47.2,94.5,64S80.8,94.5,64,94.5S33.5,80.8,33.5,64z",
    style: {
      fill: "#FFFFFF"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16);
export default __webpack_public_path__ + "static/media/icon16.1774815c7d0fcc6131833c45bbb6daea.svg";
export { ForwardRef as ReactComponent };